module.exports = __webpack_public_path__ + "img/4-7.96b19a41.png";